import Generator from '../../Generator'
import Types from '../../../actions/Types'

export default Generator.node({
  baseType: Types.PRINT.PRODUCT,
  nodeType: Generator.NODETYPE.PRINT
})



// WEBPACK FOOTER //
// ./src/reducers/root/print/product.js